import { module as modujs } from "modujs";

import { gsap } from "gsap";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				button: "click",
			},
		};
	}

	click() {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}
}
